import { FaqItem } from 'models/faq';
import { MenuLinkItem } from 'models/layout';
import * as routes from 'router/routes';

export const defaultLanguageCode = 'en';

export const privacyPolicyUrl = 'https://www.husqvarna.com/privacy';

export const termsOfUseUrl = 'https://www.husqvarnagroup.com/en/terms-use';

export const cookiePolicyUrl =
  'https://www.husqvarnagroup.com/en/cookie-policy';

export const husqvarnaSupportUrl = 'https://www.husqvarna.com/contact';

export const gardenaSupportUrl = 'https://www.gardena.com/contact';

export const mailRegex =
  /^[-!#$%&'*+/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;

export const phoneRegex = /^\+?[0-9\s\-()]{7,50}$/;

export const postalCodeRegex = /^[a-zA-Z0-9\s-]{1,50}$/;

export const nameRegex = /^[a-zA-ZÀ-ÖØ-öø-ÿ\s\-']+$/;

export const addressRegex = /^[a-zA-ZÀ-ÖØ-öø-ÿ0-9\s\-.',/#]+$/;

export const cityRegex = /^[a-zA-ZÀ-ÖØ-öø-ÿ\s\-.']+$/;

export const defaultPasswordPolicy = {
  minimumLength: 6,
  maximumLength: 256
};

export const GROUP_MIN_LENGTH = 3;

export const GROUP_MAX_LENGTH = 50;

// Group ID can contain letters, numbers, hyphens, and underscores
export const groupRegex = /^[a-zA-Z0-9\-_]+$/;

export const menuLinks: MenuLinkItem[] = [
  {
    id: 0,
    name: 'menu.profile',
    icon: 'avatar',
    link: routes.PROFILE
  },
  {
    id: 1,
    name: 'menu.account_security',
    icon: 'shield',
    link: routes.ACCOUNT_SECURITY
  },
  {
    id: 2,
    name: 'menu.learn_more',
    icon: 'lightbulb',
    link: routes.LEARN_MORE
  }
];

export const footerLinks = [
  {
    name: 'footer.privacy_policy',
    link: privacyPolicyUrl
  },
  {
    name: 'footer.terms_of_use',
    link: termsOfUseUrl
  },
  {
    name: 'footer.cookies',
    link: cookiePolicyUrl
  }
];

export const faqItems: FaqItem[] = [
  {
    category: 'basics',
    questions: ['what_is', 'services']
  },
  {
    category: 'update',
    questions: ['update_from_service', 'password_email']
  },
  {
    category: 'delete',
    questions: ['leave', 'how_to']
  }
];

export const REDIRECT_AFTER_LOGIN_KEY = 'redirectAfterLogin';
